import envConfig from 'configs/envConfig';
import { TPartnerAssets } from 'partners/types';

export const instaviewBaseUrl = `${envConfig('b2BucketUrl')}/instaview`;

export const assets: TPartnerAssets = {
  logo: `${instaviewBaseUrl}/logo.svg`,
  loginIllustration: `${instaviewBaseUrl}/loginIllustration.svg`,
  Days30EventIcon: `${instaviewBaseUrl}/30DaysEventIcon.svg`,
  CannotAddSelectedCameraIcon: `${instaviewBaseUrl}/CannotAddSelectedCamera.svg`,
  attentionIcon: `${instaviewBaseUrl}/attention.svg`,
  basicAlertsIcon: `${instaviewBaseUrl}/basicAlertsIcon.svg`,
  basicMotionAlertsImg: `${instaviewBaseUrl}/basicMotionAlerts.png`,
  clockIcon: `${instaviewBaseUrl}/clockIcon.svg`,
  decriptiveAIAlertsIcon: `${instaviewBaseUrl}/decriptiveAIAlertsIcon.svg`,
  descriptiveAIAlertsImg: `${instaviewBaseUrl}/descriptiveAIAlerts.png`,
  firmwareVersionIcon: `${instaviewBaseUrl}/firmwareVersionIcon.svg`,
  interntNotConnectedIcon: `${instaviewBaseUrl}/interntNotConnected.svg`,
  limitedSecurityImg: `${instaviewBaseUrl}/limitedSecurity.png`,
  limitedSecurityIcon: `${instaviewBaseUrl}/limitedSecurityIcon.svg`,
  locationIcon: `${instaviewBaseUrl}/location.svg`,
  logoContrastIcon: `${instaviewBaseUrl}/logoContrast.svg`,
  logoWhiteIcon: `${instaviewBaseUrl}/logoWhite.svg`,
  maxCameraLimitReachedIcon: `${instaviewBaseUrl}/maxCameraLimitReached.svg`,
  AllCamerasAddedToAccountIcon: `${instaviewBaseUrl}/AllCamerasAddedToAccount.svg`,
  noEventVideosImg: `${instaviewBaseUrl}/noEventVideos.png`,
  noEventVideosIcon: `${instaviewBaseUrl}/noEventVideosIcon.svg`,
  paymentFailedIcon: `${instaviewBaseUrl}/paymentFailedIcon.svg`,
  paymentSuccessfulIcon: `${instaviewBaseUrl}/PaymentSuccessful.svg`,
  planLevelOneIcon: `${instaviewBaseUrl}/planLevelOneIcon.svg`,
  planLevelThreeIcon: `${instaviewBaseUrl}/planLevelThreeIcon.svg`,
  planLevelTwoIcon: `${instaviewBaseUrl}/planLevelTwoIcon.svg`,
  professionMonitoringIcon: `${instaviewBaseUrl}/professionMonitoringIcons.svg`,
  professionalMonitoringImg: `${instaviewBaseUrl}/professionalMonitoring.png`,
  sampleCreditCardIcon: `${instaviewBaseUrl}/sampleCreditCard.svg`,
  FreeTrialActivatedIcon: `${instaviewBaseUrl}/FreeTrialActivated.svg`,
  upgradeSnapshotIcon: `${instaviewBaseUrl}/upgradeSnapshot.svg`,
  wifiIcon: `${instaviewBaseUrl}/wifiIcon.svg`,
  appQRCode: `${instaviewBaseUrl}/qrCode.png`
};
